import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsApiSnippetsDialogComponent } from './api-snippets-dialog.component';
import { RdsApiSnippetsTriggerComponent } from './api-snippets-trigger.component';
import { RdsCodeSnippetComponent } from './code-snippet.component';
import { RdsLocClipboardPipe } from './loc-clipboard.pipe';
import { RdsLocHtmlPipe } from './loc-html.pipe';
import { RdsVersionedCodeSnippetsComponent } from './versioned-code-snippets.component';

const declarations = [
  RdsApiSnippetsDialogComponent,
  RdsApiSnippetsTriggerComponent,
  RdsCodeSnippetComponent,
  RdsLocClipboardPipe,
  RdsLocHtmlPipe,
  RdsVersionedCodeSnippetsComponent,
];
const exports = [...declarations];

@NgModule({
  imports: [
    ClipboardModule,
    CommonModule,
    FlexModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
  ],
  declarations,
  exports,
})
export class RdsApiSnippetsModule {}

export * from './api-snippets-dialog.component';
export * from './api-snippets-trigger.component';
export * from './code-snippet.component';
export * from './loc-clipboard.pipe';
export * from './loc-html.pipe';
export * from './versioned-code-snippets.component';
